import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterLink, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-admin-page-header',
  standalone: true,
  imports: [CommonModule, RouterModule, RouterLink, TranslateModule, ButtonModule],
  templateUrl: './admin-page-header.component.html',
  styleUrl: './admin-page-header.component.scss',
})
export class AdminPageHeaderComponent {
  @Input() titleKey = '';
  @Input() descriptionKey = '';
  @Input() backLabelKey = 'COMMON.BACK';
  @Input() showBack = false;
  @Input() backLink: string | any[] = '';
  @Input() backQueryParams: Record<string, string | number | boolean> | null = null;
  @Input() contextLabelKey = '';
  @Input() contextValue = '';
}
